import { Author } from "@/components/resources/components/Author"
import { TeaserGrid } from "@/components/resources/components/TeaserGrid"
import type { AuthorPostsProps } from "@/components/resources/data/sanity/posts"

export const AuthorPage = (props: AuthorPostsProps) => {
  return (
    <div className="max-w-[1064px] mx-auto px-4 mb-8 md:mb-12 lg:mb-16 pt-8 md:pt-12 lg:pt-16">
      <div className="flex flex-col gap-6">
        <Author {...props.author} />
        <div className="flex flex-col gap-4">
          <h2 className="text-xl font-medium">Posts by author</h2>
          <TeaserGrid teasers={props.posts} />
        </div>
      </div>
    </div>
  )
}
